<template>
  <v-abstract-menu-option :dialog-width="500" :showing-dialog.sync="showingDialog">
    <template #info>Cantidad de QProductHistoryIds: {{ appSettings.historyIds.length || 'Ninguno' }}</template>
    <template #input>
      <v-card>
        <v-container class="px-2 pt-2 pb-3">
          <v-textarea
            v-model="rawInput"
            append-outer-icon="send"
            auto-grow
            autofocus
            clearable
            @click:append-outer="setHistoryIds"
            hide-details
            label="Un QProductHistoryId por línea"
            prepend-icon="fingerprint"
          />
        </v-container>
      </v-card>
    </template>
  </v-abstract-menu-option>
</template>

<script>
import VAbstractMenuOption from "./AbstractMenuOption";

/**
 * A simple component to add an option to the app settings to set a group
 * of `historyIds` to work on. It set the `appSettings.historyIds` array in
 * the store with the given `namespace`.
 *
 * The component assumes that you have an action called `setAppSettingsHistoryIds`
 * to have async reactivity to its changes that calls the mutation declared in the
 * `historyIds.mutations.js` file that can be easily added to your store module.
 * Also, you need to add the `historyIds` empty array to your store's initial state
 * for reactivity purposes.
 */
export default {
  components: {
    VAbstractMenuOption
  },
  props: {
    /**
     * The store's module's namespace where to set this setting.
     */
    namespace: {
      type: String,
      required: true
    },
    /**
     * The string or regex to use as separator of the history ids.
     */
    separator: {
      type: String,
      default: "\n"
    }
  },
  data: () => ({
    rawInput: null,
    showingDialog: false
  }),
  computed: {
    /**
     * Get the app settings from the correspondent store module.
     */
    appSettings() {
      return this.$store.state[this.namespace].appSettings;
    },
    /**
     * Get and set the `historyIds` app setting.
     */
    historyIds: {
      get() {
        return this.appSettings.historyIds;
      },
      set(value) {
        this.$store.dispatch(
          `${this.namespace}/setAppSettingsHistoryIds`,
          value
        );
      }
    }
  },
  methods: {
    /**
     * Split the input and set the ids in the store.
     */
    setHistoryIds() {
      if (!this.rawInput) {
        this.historyIds = [];
      } else {
        this.historyIds = this.rawInput
          .split(this.separator)
          .map(id => id.trim())
          .filter(id => !!id);
      }

      this.showingDialog = false;
    },
    /**
     * Update the input of the component to show the elements of the store.
     */
    updateInput() {
      this.rawInput = this.historyIds.join("\n");
    }
  },
  /**
   * Update the input if the store was populated with ids before the
   * creation of the component.
   */
  created() {
    this.updateInput();
  },
  watch: {
    /**
     * Watch the setting to populate the input with its values.
     */
    historyIds() {
      this.updateInput();
    }
  }
};
</script>